export enum AiAssistantAnalyticsEvents {
  AiAssistantCardClicked = 'ai_assistant_card_clicked',
  SuggestAiAssistantOptionSelected = 'suggest_ai_assistant_option_selected'
}

export enum AiAssistantOption {
  CareTeam = 'care_team',
  FrontDesk = 'front_desk'
}

export enum BannerAnalyticsEvents {
  BannerActionClick = 'banner_action_click',
  BannerView = 'banner_view',
  BreakageCancelLinkDropped = 'breakage_cancel_link_dropped'
}

export enum BillingAnalyticsEvents {
  CancelFlowReturn = 'billing_cancel_flow_return',
  CancelMembershipClicked = 'billing_cancel_memb_btn_click',
  PartnerBenefitAddCardClicked = 'billing_partner_benefit_add_card_clicked',
  PartnerBenefitCancelClicked = 'billing_partner_benefit_cancel_clicked',
  PartnerBenefitKeepClicked = 'billing_partner_benefit_keep_clicked'
}

export enum ClickToCallAnalyticsEvents {
  CallCompleted = 'click_to_call_call_completed',
  CallConnected = 'click_to_call_call_connected',
  CallRetryClicked = 'click_to_call_retry_clicked',
  FabClicked = 'click_to_call_fab_clicked',
  FabImpression = 'click_to_call_fab_impression',
  MessageClicked = 'click_to_call_message_clicked',
  TopicSelected = 'click_to_call_topic_selected',
  TriggerFailed = 'click_to_call_trigger_failed',
  TriggerSubmitted = 'click_to_call_trigger_submitted',
  TriggerSucceeded = 'click_to_call_trigger_succeeded'
}

export enum InsuranceWizardAnalyticsEvents {
  CardsUploaded = 'insurance_wizard_cards_uploaded',
  CommitFailed = 'insurance_wizard_commit_failed',
  CommitSubmitted = 'insurance_wizard_commit_submitted',
  CommitSucceeded = 'insurance_wizard_commit_succeeded',
  CoverageSelectionMade = 'insurance_wizard_coverage_selection_made',
  DeletePrimaryFallbackChosen = 'insurance_wizard_delete_primary_fallback_chosen',
  MedicareGateAnswered = 'insurance_wizard_medicare_gate_answered',
  MemberIdSubmitted = 'insurance_wizard_member_id_submitted',
  PlanChangeReviewed = 'insurance_wizard_plan_change_reviewed',
  PlanPicked = 'insurance_wizard_plan_picked',
  PreviewReturned = 'insurance_wizard_preview_returned',
  WizardCancelled = 'insurance_wizard_cancelled',
  WizardOpened = 'insurance_wizard_opened'
}

export enum ZoomChatAnalyticsEvents {
  WidgetImpression = 'zoom_chat_widget_impression'
}
